var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "casino-search-result" },
    [
      _vm.searchResults
        ? _c("casino-tabs", {
            staticClass: "casino-page-header-item",
            attrs: {
              setDefaultTab: 1,
              section: "filterAndSort",
              pageType: "search",
              itemCount: _vm.searchResults && _vm.searchResults.gameIds.length,
              providers: _vm.providers,
              themeList: _vm.themeList,
              filteredItems: _vm.filteredItems,
              originalPreparedData: _vm.originalPreparedData,
              selectedFilterNumberDisplay: _vm.selectedFilterNumberDisplay
            },
            on: {
              sortTypeSelected: _vm.sortGames,
              filterSelected: _vm.filterSelected
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.searchResults
        ? _c("casino-grid-view", {
            key: _vm.componentKey,
            staticClass: "search-grid-view",
            attrs: {
              data: _vm.filterGamesInfoDataByGroup(_vm.searchResults.gameIds),
              groupData: _vm.searchResults
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.searchResults && !_vm.searchPhrase && !_vm.gamesLoaded
        ? _c("section", { staticClass: "before-search-start" }, [
            _c("div", { staticClass: "header" }, [
              _vm._v(_vm._s(_vm.$t("Casino.Search.ForGameOrByProvider")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "body" }, [
              _vm._v(_vm._s(_vm.$t("Casino.Search.ResultsWillShowAsYouType")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.searchResults &&
      _vm.gamesLoaded &&
      _vm.searchPhrase.length >= _vm.numOfCharsToStartSearch
        ? _c("section", { staticClass: "search-no-results" }, [
            _c("div", { staticClass: "search-header" }, [
              _vm._v(_vm._s(_vm.$t("Casino.Search.NoResultsFound")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "body" }, [
              _c("div", { staticClass: "suggestions" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("Casino.Search.Suggestions")))
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      " - " + _vm._s(_vm.$t("Casino.Search.Suggestions_1"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      " - " + _vm._s(_vm.$t("Casino.Search.Suggestions_2"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      " - " + _vm._s(_vm.$t("Casino.Search.Suggestions_3"))
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a50f5b94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a50f5b94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoSearch/casinoSearchResult.vue
// module id = null
// module chunks = 